import { Heading, HeadingRow } from "cai-fusion"
import { ReactComponent as IconSpark } from "../../../../../images/icon-spark.svg"

import { useSiftV2 } from "../../../contexts/siftV2Context"

const SiftOpportunityInsightBlock = () => {

    const { placeholderInsights } = useSiftV2();

    return (
        <div className="o-block o-block--ai l-mb-sm">
            <Heading size={3} className="l-mb-xs">
                {/* We need a space between the text and the icon, and this is the way to do it! */}
                {`Symphony Insights `}
                <IconSpark className="a-icon a-icon--ai a-icon--x-small" />
            </Heading>
            <div className="o-form l-mt-xs">
                <div className="row">
                    <div className="col-md-12">
                        <ul style={{"list-style": "square"}}>
                            {placeholderInsights.map((insight) => (
                                <li><p>{insight}</p></li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SiftOpportunityInsightBlock;